module.exports = {
  requestAnwsersSubmit: [
    'token',
    [
      {
        value: 'test',
        elementId: 'tin_8PEzLX',
      },
    ],
    'pg_bkzO08',
  ],
  '/api/internal/answers': {
    data: {
      result: {
        id: 'res_X0bvAk',
        version: 0,
        start_at: '2016-12-09T15:12:22.194Z',
        end_at: null,
        survey_id: 'srv_eX9eoX',
        last_position: 1,
        current_page_id: 'pg_bkzO08',
        state: 'started',
        remaining_rewards: 'none',
        display_order: ['pg_bkzO08', 'pg_4X7PlQ'],
        participant: {
          id: 'pcp_X0bvAk',
          email: null,
          first_name: null,
          last_name: null,
          user_id: 'usr_w8Nb8d',
          provider: null,
          provider_first_name: null,
          provider_last_name: null,
          provider_id: null,
          provider_email: null,
          provider_confirmed: null,
          provider_json: null,
          provider_token: null,
          provider_expires_at: null,
          provider_refresh_token: null,
          provider_timezone: null,
          provider_locale: null,
          provider_profile_link: null,
          provider_profile_image_url: null,
        },
        answers: [
          {
            id: 'ans_g8PL38',
            result_id: 'res_X0bvAk',
            name: 'tin_8PEzLX',
            value: 'test',
            element_id: 'tin_8PEzLX',
            label: 'Do you need something?',
            position: 1,
            meta: null,
          },
        ],
      },
      conditions: [],
    },
    status: 200,
    statusText: 'OK',
    headers: {
      'content-type': 'application/json; charset=utf-8',
      'cache-control': 'max-age=0, private, must-revalidate',
    },
  },
};
